import React from 'react';
import './style.scss';
import {
  MarketNftStatuses,
  MarketPageModeProps
} from '../../../components/pages/marketPage/Interfaces';
import MarketNftDescription from '../../../components/pages/marketPage/description';
import NftImage from '../../../components/general/nft/image';
import MarketPageActionButton from '../../../components/pages/marketPage/actionButton';
import MarketPageArrows from '../../../components/pages/marketPage/arrows';
import MarketPagePromoCode from '../../../components/pages/marketPage/promoCode';

const MarketPageMobile = ({
  status,
  nft,
  freeNft,
  actionLoading,
  setActionLoading
}: MarketPageModeProps) => {
  const { nftLoading, handleRightClick, handleLeftClick, update } = freeNft;

  return (
    <div className='market-page-mobile'>
      <MarketNftDescription
        nft={nft}
        status={status}
        className='mrw-description'
        loading={nftLoading}
        includeHint
        disableTraits
      />
      <div className='market-image-wrapper'>
        <NftImage
          nft={nft}
          className='market-image'
          loading={nftLoading}
          disabled={
            status !== MarketNftStatuses.AVAILABLE &&
            status !== MarketNftStatuses.MINTED
          }
        />
        <MarketPageArrows
          handleLeft={handleLeftClick}
          handleRight={handleRightClick}
          inactive={nftLoading || actionLoading}
          className='mrw-arrows'
        />
      </div>
      <div className='mrw-footer'>
        <MarketPageActionButton
          nft={nft}
          status={status}
          inactive={nftLoading}
          update={update}
          loading={actionLoading}
          setLoading={setActionLoading}
          className='mrw-button'
        />
        <MarketPagePromoCode status={status} />
      </div>
    </div>
  );
};

export default MarketPageMobile;
